
import { defineComponent, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { uploadAvatar } from '@/api/profile'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  props: {
    avatarUrl: {
      type: String,
      default: '',
    },
  },
  setup(_, { emit }) {
    const { t } = useI18n()
    const uploadRef = ref()

    const handleSuccess = () => {
      uploadRef.value.clearFiles()
    }
    const handleUpload = async (options: any) => {
      const fd = new FormData()
      fd.append('file', options.file)
      const res = await uploadAvatar(fd)
      if (res.data) {
        emit('uploadSuccess')
      }
    }
    const beforeUpload = (file) => {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        ElMessage.error(t('profile.isLt2M'))
      }
      return isLt2M
    }

    return {
      handleUpload,
      beforeUpload,
      handleSuccess,
      uploadRef,
    }
  },
})
